import script from "./SkcillGood.vue?vue&type=script&setup=true&lang=js"
export * from "./SkcillGood.vue?vue&type=script&setup=true&lang=js"

import "./SkcillGood.vue?vue&type=style&index=0&id=157a3f75&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-157a3f75"]])

export default __exports__